import React, { useState, useContext, useEffect } from "react";
import FuncionesContext from "../context/FuncionesContext";
import TextArea from "./TextArea";
import TextField from "@mui/material/TextField";
import { useRefDataStore } from "../../..";
import { getAtributo } from "../context/FuncionesContext";
import Nullifier from "./Nullifier";

const InputAreaEditable = ({ data, cab, campokey, type, id_elemento, valor, updateid }) => {
  const { superSubmit, validarRegex, refrescarConfiguracion } = useContext(FuncionesContext);

  const [v, setStore] = useRefDataStore((s) => s[data._key + campokey]);
  const [update_id] = useRefDataStore((s) => s[data._key + cab.update_id_alias]);

  const [value, setValue] = useState(v ?? valor);
  const [lastValue, setLastvalue] = useState(v);
  const [updateId, setUpdateId] = useState(update_id ?? updateid);

  const [error, setError] = useState(false);
  const [helper, setHelper] = useState("");

  const nombre = (() => (cab.nombre_alias ? data[cab.nombre_alias] : cab.nombre))();

  const disabled = data[cab.id_a + "_disabled"]
    ? data[cab.id_a + "_disabled"] === "s"
    : cab.disabled === "s";

  const permite_null = getAtributo("permite_null", data, cab) === 's'

  const icono_obligatorio =
    data[cab.id_a + "_icono_obligatorio"] === "s" || cab.icono_obligatorio === "s";

  let classNames = data[cab.id_a + "_className"] ?? cab.className;

  const handleCancelar = () => {
    setValue(lastValue);
    const inputElement = document.getElementById(id_elemento + "_input");
    if (inputElement) inputElement.value = lastValue ?? "";
  };

  const handleGuardar = async (e) => {
    const val = e.target.value;
    if (val === lastValue || (val === "" && lastValue === null)) return;
    if (val === null || lastValue?.toString() === val.toString().trim()) return;

    if (validarRegex && !validarRegex(val, cab.validacion_regex, cab)) {
      setError(true);
      setHelper(cab.helperText || "Formato inválido");
      handleCancelar();
      return;
    }

    setError(false);
    setHelper("");

    const { id_a } = cab;

    superSubmit({ valor: val, id_a, update_id: updateId, handleCancelar, cab, data })
      .then((result) => {
        setLastvalue(() => val);
        setStore({ [data._key + campokey]: val });
        if (!updateId) {
          setStore({ [data._key + cab.update_id_alias]: result.data.registro.id });
          setUpdateId(result.data.registro.id);
        }
        if (cab?.refresca_config === "s") {
          try {
            refrescarConfiguracion({ cab });
          } catch (e) {
            console.log("Error refrescando configuración", e);
          }
        }
        return result;
      })
      .catch((err) => {
        handleCancelar();
        console.log("Cancelado ", err);
      });
  };

  (() => {
    if (updateId) {
      classNames = `${classNames} ${data[cab.id_a + "_update_className"] ?? cab.update_className}`;
      return;
    }
    classNames = classNames + " sinUpdateId";
  })();

  useEffect(() => {
    setValue(v);
    setUpdateId(update_id);
  }, [v, update_id]);

  return (
    <div style={{ width: "100%" }} id={id_elemento} className="tarjeta_grid_item_label_item">
      {nombre && nombre.trim() !== "" ? <div className="vista_label">{nombre}{':'}</div> : null}

      <div style={{ display: "flex", alignItems: "flex-start", gap: "4px", width: "100%" }}>
        {type === "number" ? (
          classNames?.includes("native") ? (
            <div style={{ position: "relative", width: cab.width_input }}>
              <input
                id={id_elemento + "_input"}
                type="number"
                onBlur={handleGuardar}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleGuardar(e)}
                value={value ?? ""}
                onChange={(e) => setValue(e.target.value)}
                disabled={disabled}
                className={classNames + (error ? " input_error" : "")}
                style={{ textAlign: "right", fontSize: "1em", width: "100%" }}
              />
              {error && (
                <small
                  style={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    color: "#d32f2f",
                    margin: 0,
                    height: 0,
                    zIndex: 9,
                    width: "max-content",
                  }}
                >
                  {helper}
                </small>
              )}
            </div>
          ) : (
            <div style={{ position: "relative", width: cab.width_input }}>
              <TextField
                id={cab.id_a}
                type="number"
                onBlur={handleGuardar}
                onKeyDown={(e) => e.key === "Enter" && handleGuardar(e)}
                value={value ?? ""}
                onChange={(e) => setValue(e.target.value)}
                error={error}
                helperText={""}
                inputProps={{
                  className: `input_altura ${(disabled ? "textField_disabled " : "") + (error ? "input_error" : "")}`,
                  style: { textAlign: cab.align ?? "right", width: "100%" },
                }}
                disabled={disabled}
                className={` ${disabled ? classNames + " textField_disabled" : classNames}`}
                variant="outlined"
                fullWidth
              />
              {permite_null && (
                <Nullifier
                  onClick={() => handleGuardar({ target: { value: "null" } })}
                  className="nullifier_button_floating"
                />
              )}
              {error && (
                <small
                  style={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    color: "#d32f2f",
                    margin: 0,
                    height: 0,
                    zIndex: 9,
                    width: "max-content",
                  }}
                >
                  {helper}
                </small>
              )}

            </div>
          )
        ) : (
          <div
            style={{
              position: "relative",
              width: cab.width_input && cab.width_input.trim() !== "" ? cab.width_input : "100%",
            }}
          >
            <TextArea
              disabled={disabled}
              className={
                (disabled ? classNames + " textArea_disabled" : classNames) +
                (error ? " input_error" : "")
              }
              value={value}
              setValue={setValue}
              onEnter={handleGuardar}
              onBlur={handleGuardar}
              style={{ width: "100%" }}
              id={id_elemento + "_input"}
            />
            {error && (
              <small
                style={{
                  position: "absolute",
                  left: 0,
                  bottom: 0,
                  color: "#d32f2f",
                  margin: 0,
                  height: 0,
                  zIndex: 9,
                  width: "max-content",
                }}
              >
                {helper}
              </small>
            )}
          </div>
        )}

        {icono_obligatorio && (
          <span className="icono_obligatorio">
            *
          </span>
        )}
      </div>
    </div>
  );
};

export default InputAreaEditable;
